module.exports = __webpack_public_path__ + "img/429.4b2c6131.jpg";